import { useEffect, useMemo } from 'react';

import { DrugPackagingsForm } from '@/components/drug-packagings-form';
import { Button } from '@/components-new/button';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '@/components-new/dialog';
import { Spinner } from '@/components-new/spinner';
import { MarketBasketDrugPackaging } from '@/features/market-baskets/types/market-basket';
import { useDrugPackagingForm } from '@/hooks/use-drug-packaging-form';
import { drugName } from '@/utils/drugs';

type EditDrugPackagingDialogProps = {
  marketBasketDrugPackaging: MarketBasketDrugPackaging;
  isOpen: boolean;
  onClose: () => void;
  onSaved: () => void;
};

export const EditDrugPackagingDialog = ({ isOpen, onClose, onSaved, marketBasketDrugPackaging }: EditDrugPackagingDialogProps) => {
  const {
    form,
    submitForm,
    savingDrugPackaging,
    fetchDrugPackaging,
    fetchingDrugPackaging,
    savedDrugPackagingSuccessfully
  } = useDrugPackagingForm();

  const drugPackagingName = useMemo(() => {
    return !marketBasketDrugPackaging
      ? ''
      : `${marketBasketDrugPackaging.ndc} - ${drugName(marketBasketDrugPackaging?.drug)} ${marketBasketDrugPackaging?.name}`;
  }, [marketBasketDrugPackaging]);

  useEffect(() => {
    if (!savedDrugPackagingSuccessfully) return;
    form.reset();
    onSaved();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedDrugPackagingSuccessfully]);

  useEffect(() => {
    if (!isOpen) return;

    // @ts-expect-error TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
    fetchDrugPackaging(marketBasketDrugPackaging.drug?.id, marketBasketDrugPackaging.ndc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleFormSubmit = () => {
    // @ts-expect-error TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
    submitForm(marketBasketDrugPackaging.drug?.id, marketBasketDrugPackaging.ndc);
  };

  const handleDialogClose = () => {
    form.reset();
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={savingDrugPackaging ? () => {} : handleDialogClose}>
      <DialogTitle>Edit Drug Packaging</DialogTitle>
      {drugPackagingName && (
        <p className="mt-1 text-sm text-zinc-500">{drugPackagingName}</p>
      )}
      <DialogBody>
        {fetchingDrugPackaging && (
          <div className="flex justify-center">
            <Spinner />
          </div>
        )}
        {!fetchingDrugPackaging && <DrugPackagingsForm formControl={form.control} errors={form.formState.errors}/>}
      </DialogBody>
      <DialogActions>
        <Button
          plain
          onClick={handleDialogClose}
          disabled={savingDrugPackaging}
        >Cancel</Button>
        <Button
          onClick={handleFormSubmit}
          disabled={!form.formState.isValid || savingDrugPackaging}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
